<template>
  <div class="container">
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h1 class="font-24 mb-24">
      Porównanie ofert
    </h1>
    <T1SchowekCompareOffers />
  </div>
</template>

<script>
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1SchowekCompareOffers from "./T1SchowekCompareOffers";

export default {
  name: "clipboard-compare-content",
  data: () => ({
    selectedOffersCount: 0,
  }),
  components: {
    T1Breadcrumbs,
    T1SchowekCompareOffers,
  },
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push(
        { name: "Schowek ofert", link: "/oferta/schowek.xml" },
        { name: "Porównianie ofert", link: "" }
      );
      return crumbsArr;
    },
  },
  mounted() {
    let that = this;
    /*this.$root.$on("update:selectedOffersCount", (val) => {
      that.selectedOffersCount = val;
    });*/
  },
};
</script>
